module.exports = ["toEnglish","toEdition"]


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/langs.json
// module id = 864
// module chunks = 0